import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"
import aboutStyles from "./about.module.scss"

const About = () => {
  return (
    <Layout>
      <Head title="O mnie" />
      <section className={aboutStyles.about}>
        <h1>O Mnie</h1>
        <div className={aboutStyles.about__container}>
          <img src={require("../img/Derophotohero.jpg")} alt="hero-img"></img>
          <div className={aboutStyles.textbox}>
            <div className={aboutStyles.textbox__heading}>
              <h2>DEROFOTO</h2>
             
              <img
                src={require("../img/line_small_hr.svg")}
                alt="hero-img"
              ></img>
            </div>

            <p>
              Witam, strona którą obecnie oglądacie jest projektem reprezentatywnym opartym o realizacje dla klienta która niedawno przygotowywaliśmy.
              Strona jest zbudowana na silniku frontendowym Gatsby, dzięki temu strona działa bardzo szybko i ma pełną optymalizacje SEO.
              Dzięki systemowi do zarządzania treścią CMS treść na stronie jest dodawana przez właścicela własnoręcznie bez znajomości programowania.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default About
